
import React from "react";

import CleanUpTable from "../component/CleanUpTable";

const CleanUpTableContainer = ({ pageId }) => (<CleanUpTable pageId={ pageId } />)

export default CleanUpTableContainer; 